module.exports = __webpack_public_path__ + "images/slv_feuer.png?c13a1ff2e7b286dfa35d33a94bfc5164";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slv_feuer.png
// module id = eNmx
// module chunks = 0